import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const StudySeries = () => {
    const { chartData } = useIdentificationChartsDataContext();


    return (
        <SimpleBars
            title={'Séries de estudo'}
            horizontal={false}
            subtitles={chartData?.studySeries?.map((item) => item.description)}
            values={chartData?.studySeries?.map((item) => item.total  ||  0)}
        />
    );
};
